import {
  DestroyRef,
  inject,
  Injectable,
  signal } from '@angular/core';
import { CalendarEvent } from 'src/app/shared/calendar-event/ports/calendar-event.port';
import { CALENDAR_EVENT_SERVICE } from 'src/app/shared/calendar-event/token/calendar-event.token';
import { ConsumptionStorePort } from '../../domain/ports/consumption-store.port';

export interface ConsumptionState {
  calendarEvent: CalendarEvent | null;
}

@Injectable({ providedIn: 'root' })
export class ConsumptionStore implements ConsumptionStorePort {
  private readonly calendarEventService = inject(CALENDAR_EVENT_SERVICE);
  private readonly destroyRef = inject(DestroyRef);

  private readonly _state = signal<ConsumptionState>({
    calendarEvent: null,
  });

  readonly state = this._state.asReadonly();

  get calendarEvent(): CalendarEvent | null {
    return this._state().calendarEvent;
  }

  get eventName(): string {
    return this._state().calendarEvent?.name ?? '';
  }

  setCalendarEvent(calendarEvent: CalendarEvent): void {
    this._state.set({ calendarEvent });
  }

  clearCalendarEvent(): void {
    this._state.set({ calendarEvent: null });
  }

}